export default {
  "arena/arena": {
    en: "Arenas",
    fr: "Arènes",
  },
  "arena/created": {
    en: "Created",
    fr: "À venir",
  },
  "arena/started": {
    en: "Started",
    fr: "En cours",
  },
  "arena/join": {
    en: "Join",
    fr: "Rejoindre",
  },
  "arena/waiting": {
    en: "Waiting to be paired",
    fr: "En attente d'appariement",
  },
  "arena/leave": {
    en: "Leave arena",
    fr: "Se retirer",
  },
  "arena/info": {
    en: `
    We only display arenas that are started or about to start, 
    and with time controls which feel compatible with this application. 
    And we do not support starting positions, yet.
    `,
    fr: `
    Ne sont montrées que les arènes qui sont en cours ou sur
    le point de commencer. De plus, ne sont pas montées celles
    dont le contôle du temps est compatible avec l'usage 
    de cette application. 
    `,
  },
};
